<app-page-meta pageTitle="finzy - Loan Agreements"></app-page-meta>
<app-header></app-header>

<div class="container-fluid">
  <div class="row">
    <app-investormenu></app-investormenu>

    <div class="col-xs-12 col-md-10 col-lg-11 main-content">

      <div class="row finzy-row5">
        <p class="finzy-p-h">Loan Agreements</p>

        <div *ngIf="consent_list?.length">
          <p class="finzy-txt-ps72">Here are the loan agreements for the loans that you have invested in.</p>
          <p class="finzy-txt-ps72">You can also find them in the loan details view in your investment dashboard.</p>
        </div>

        <div *ngIf="consent_list?.length === 0">
          <p class="finzy-txt-ps72">Once the loans you have invested in have been disbursed to the borrower,<br/>you
            will see the executed loan agreements here.</p>
        </div>

      </div>

      <div class="row finzy-row10gray" *ngIf="consent_list?.length == 0">
        <p class="greydivp1"><img src="../../assets/images/consent_large.png" alt="Loan agreements"></p>
        <p class="greydivp">Currently there are no loan agreements to display.</p>
      </div>

      <form method="post" class="finzy-consent-form" #h="ngForm" *ngIf="consent_list?.length > 0">
        <div class="row finzy-row10">
          <div class="col-xs-12 table-container">
            <mat-table #table [dataSource]="dataSource" matSort>
              <ng-container matColumnDef="generated_loan_id">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Loan ID</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.loan_id.generated_loan_id}}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="portfolio_name">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Portfolio Name</mat-header-cell>
                <mat-cell *matCellDef="let element"><span
                        style="text-transform: uppercase;">{{element.portfolio_name}}</span></mat-cell>
              </ng-container>

              <ng-container matColumnDef="disbursal_date">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Disbursal Date</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.disbursal_date}}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="sign_documents" #linksdiv>
                <mat-header-cell *matHeaderCellDef> Contracts</mat-header-cell>
                <mat-cell *matCellDef="let element"><a target="_blank" *ngIf="element.sign_documents && !isMobileApp"
                                                       (click)="downloadContractDoc(element.sign_documents)" class="viewcontracts">View
                  Agreements</a>
                  <a target="_blank" *ngIf="element.sign_documents && isMobileApp"
                  (click)="downloadFile(element.sign_documents)" class="viewcontracts">View
Agreements</a> 
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>

            <mat-paginator #paginator [length]="5"
                           [pageSize]="5"
                           [pageSizeOptions]="[5, 10, 20]">
            </mat-paginator>
          </div>
        </div>
      </form>
    </div>

  </div>
</div>

<app-footer></app-footer>
